import { render, staticRenderFns } from "./GhostInput.vue?vue&type=template&id=38234ef7&scoped=true&"
import script from "./GhostInput.vue?vue&type=script&lang=js&"
export * from "./GhostInput.vue?vue&type=script&lang=js&"
import style0 from "./GhostInput.vue?vue&type=style&index=0&id=38234ef7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38234ef7",
  null
  
)

export default component.exports